/* import __COLOCATED_TEMPLATE__ from './prism-step-counter.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';

/**
 * @class PrismStepCounter
 */
export default Component.extend({
  classNames: ['prism-step-counter'],
  /**
   * @argument currentStep
   * @type {Number}
   */
  currentStep: null,
  /**
   * @argument totalSteps
   * @type {Number}
   */
  totalSteps: null,
  /**
   * If true displays a label next to the counter indicating numerically what
   * the current step is.
   *
   * Defaults to `true`.
   *
   * @argument showLabel
   * @type {Boolean}
   */
  showLabel: true,
  /**
   * Class string applied to step blocks that are completed.
   *
   * @argument completedStepClass
   * @type {String}
   */
  completedStepClass: 'prism-step-counter__step-line--completed',
  steps: computed('totalSteps', 'currentStep', function () {
    const totalSteps = this.totalSteps;
    const currentStep = this.currentStep;
    return [...new Array(totalSteps)].map((_, i) => {
      return {
        completed: i < currentStep
      };
    });
  })
});